import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Typography,
  CardBody,
  CardTitle,
  IconButton,
} from '@one-thd/sui-atomic-components';
import { TrashCan } from '@one-thd/sui-icons';

import {
  CustomCardActions,
  CustomCard,
  CustomContent,
} from './styles';

function StairModelCard(props) {

  const {
    name,
    steps,
    id,
    deleteStair,
    editStair,
    forwardedRef,
  } = props;

  return (
    <CustomCard id={id} ref={forwardedRef}>

      <CustomContent>
        <CardTitle
          header={(<Typography variant="h3" weight="bold">{name}</Typography>)}
          subheader={(<Typography>{steps}&nbsp; steps</Typography>)}
        />
        <CardBody>
          <CustomCardActions>
            <Button
              variant="text"
              style={{
                justifyContent: 'start',
                alignItems: 'end',
                lineHeight: '1',
                borderBottomWidth: '1px',
                borderStyle: 'inset',
                paddingLeft: '0.1rem',
                paddingRight: '0.1rem'
              }}
              onClick={editStair}
            > Edit
            </Button>
            <IconButton
              icon={TrashCan}
              arial-label="Delete stair"
              style={{ marginTop: '20px' }}
              onClick={deleteStair}
            />
          </CustomCardActions>
        </CardBody>
      </CustomContent>

    </CustomCard>
  );
}

StairModelCard.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  steps: PropTypes.string.isRequired,
  deleteStair: PropTypes.func.isRequired,
  editStair: PropTypes.func.isRequired,
  forwardedRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: typeof Element !== 'undefined' ? PropTypes.instanceOf(Element) : PropTypes.any })
  ]),
};

StairModelCard.defaultProps = {
  forwardedRef: {},
};

export default StairModelCard;
